export default "__VITE_ASSET__DeFf$j5$__"